const form = {
  formFieldWrap: {
    clearFieldBtn: 'Borrar',
  },
};

export default form;
